function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
import { getCurrentInstance } from '@vue/composition-api';
/** 判断是否不是 undefined */

export function isNotUndefined(val) {
  return typeof val !== 'undefined';
}
export function withInstall(component) {
  component.install = function install(vue) {
    if (component.name) {
      vue.component(component.name, component);
    }
  };
  return component;
}
export function extend(target, source) {
  Object.keys(source).forEach(function (key) {
    target[key] = source[key];
  });
  return target;
}
/**
 * 暴露方法给组件外部通过$refs引用
 */

export function useExpose(apis) {
  var instance = getCurrentInstance();
  if (instance) {
    Object.assign(instance.proxy, apis);
  }
}
/**
 * @param  {unknown} val
 * @returns boolean
 */

export var isObject = function isObject(val) {
  return val !== null && _typeof(val) === 'object';
};
var rafFallback = function rafFallback(handler) {
  return window.setTimeout(handler, 16);
};
var _requestAnimationFrame = window.requestAnimationFrame || rafFallback;
var _cancelAnimationFrame = window.cancelAnimationFrame || window.clearTimeout;
/**
 * @description requestAnimationFrame
 * @param  {()=>void} handler
 * @param  {number} timeout?
 */

export var raf = function raf(handler) {
  return _requestAnimationFrame.call(window, handler);
};
/**
 * @description 两次requestAnimationFrame间隔
 * @param  {()=>void} handler
 * @param  {number} timeout?
 */

export var doubleRaf = function doubleRaf(handler) {
  return raf(function () {
    return raf(handler);
  });
};
/**
 * @description cancelAnimationFrame
 * @param  {number} handle
 */

export var cancelRaf = function cancelRaf(handle) {
  _cancelAnimationFrame.call(window, handle);
};
export function getElementLeft(element) {
  var actualLeft = element.offsetLeft;
  var current = element.offsetParent;
  while (current !== null) {
    actualLeft += current.offsetLeft;
    current = current.offsetParent;
  }
  return actualLeft;
}
export function getElementTop(element) {
  var actualTop = element.offsetTop;
  var current = element.offsetParent;
  while (current !== null) {
    actualTop += current.offsetTop;
    current = current.offsetParent;
  }
  return actualTop;
}
/**
 * 将rpx根据414稿转成px，保留小数点后5位，unitPrecision: 5
 */

export function rpx2px(px) {
  return Number((window.screen.availWidth * (px / 414)).toFixed(5));
}
/**
 * @description 为属性固定的静态对象赋值,例如reactive，替代通过.多次访问 减少代码量
 * @param  {T} target
 * @param  {T} source
 */

export function staticObjectAssign(target, source) {
  Object.keys(source).forEach(function (key) {
    if (source[key] !== undefined && Object.prototype.hasOwnProperty.call(target, key)) {
      target[key] = source[key];
    }
  });
}